module.exports = __webpack_public_path__ + "img/20191109144438360截图20191109140043136.12a6fd4d.jpg";